import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Button, Spinner } from '@openedx/paragon';
// eslint-disable-next-line import/no-extraneous-dependencies
import { RiArrowLeftSLine } from '@remixicon/react';

import { usePathwayById } from './usePathwayById';
import messages from './messages';

import './componentView.scss';

const ComponentViewPage = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { pathwayId: rawPathwayId, componentId } = useParams();
  const pathwayId = decodeURIComponent(rawPathwayId || '');

  const { components, loading } = usePathwayById(pathwayId);
  const component = components.find((c) => c.id === componentId) || null;

  const goBack = () => navigate(`/pathways/${encodeURIComponent(pathwayId)}`);

  if (loading && !component) {
    return (
      <div className="component-view__state">
        <Spinner animation="border" screenReaderText={intl.formatMessage(messages.loadingPathway)} />
      </div>
    );
  }

  if (!component || !component.contentId) {
    return (
      <div className="component-view__state component-view__state--error">
        <p>{intl.formatMessage(messages.componentNotFound)}</p>
        <Button variant="tertiary" onClick={goBack}>{intl.formatMessage(messages.backToPath)}</Button>
      </div>
    );
  }

  const xblockUrl = `${getConfig().LMS_BASE_URL}/xblock/${component.contentId}`;

  return (
    <div className="component-view">
      <Button
        variant="tertiary"
        iconBefore={RiArrowLeftSLine}
        onClick={goBack}
        className="component-view__back"
      >
        {intl.formatMessage(messages.backToPath)}
      </Button>
      <div className="component-view__frame-wrap">
        <iframe
          src={xblockUrl}
          title={component.displayName}
          className="component-view__frame"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default ComponentViewPage;
